import { Components } from 'formiojs';
import { FormioUtils } from '@formio/angular';
import _ from 'lodash';
export class CustomPasswordComponent extends Components.components.password {
    static schema() {
        return Components.components.password.schema({
            type: 'customPassword',
        });
    }
    static get builderInfo() {
        return {
            title: 'Custom Password',
            group: 'advanced',
            icon: 'fa fa-key',
            weight: 70,
            documentation: 'http://help.form.io/userguide/#custom',
            schema: CustomPasswordComponent.schema()
        };
    }
    showPassword = false;
    constructor(component, options, data) {
        super(component, options, data);
    }
    // @ts-expect-error: TS doesn't like overriding a readonly property with a getter...apparently
    get defaultSchema() {
        return CustomPasswordComponent.schema();
    }
    get suffix() {
        const toggleIcon = this.renderTemplate('icon', {
            ref: 'suffix-icon',
            className: this.iconClass(this.showPassword ? 'eye-slash' : 'eye', false),
            styles: '',
            content: ''
        }).trim();
        return FormioUtils.convertStringToHTMLElement(toggleIcon, '[ref="suffix-icon"]');
    }
    // @ts-expect-error: TS doesn't like overriding a readonly property with a getter...apparently
    get inputInfo() {
        const info = super.inputInfo;
        info.attr.type = this.showPassword ? 'text' : 'password';
        info.attr.autocomplete = 'off';
        return info;
    }
    // Attach click handler to suffix button to toggle password visibility.
    attach(element) {
        const attachResult = super.attach(element);
        _.forEach(this.refs.suffix, (suffix) => {
            // Add border radius class to always force the rounded right side
            // Noticed the CSS rules were breaking when LastPass extension was injecting elements
            suffix.classList.add('border-round-right-sm');
            this.addEventListener(suffix, 'click', () => {
                this.showPassword = !this.showPassword;
                this.redraw();
            });
        });
        return attachResult;
    }
}
